export default __webpack_public_path__ + "static/media/thankLogo.8cf6047f.png";